import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: background;\n  flex: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '@xstyled/styled-components';
import { AppHeader } from './AppHeader';
import { Head } from './Head';
var StickyHeader = styled.div(_templateObject());
var Main = styled.main(_templateObject2());
var Container = styled.div(_templateObject3());
export function PageLayout(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Head, {
    title: title
  }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(StickyHeader, null, /*#__PURE__*/React.createElement(AppHeader, null)), /*#__PURE__*/React.createElement(Main, {
    id: "main"
  }, children)));
}